export enum PRODUCT_TYPE {
  ENT = 'ENT',
  PLA = 'PLA',
  DES = 'DES',
  SNA = 'SNA',
  BOI = 'BOI',
  SAL = 'SAL',
  GOU = 'GOU',
  FRU = 'FRU',
  FOR = 'FOR',
  FRO = 'FRO',
  EGG = 'EGG',
  PAI = 'PAI',
  VIE = 'VIE',
  GAT = 'GAT',
  BOC = 'BOC',
}

export enum SERVICE_TYPE {
  PD = 'PD',
  CO = 'CO',
  DJ = 'DJ',
  GO = 'GO',
  SO = 'SO',
}
